// Mock data for Evolution Cell Phone Repairs

export const businessInfo = {
  name: "Evolution Cell Phone Repairs",
  tagline: "Expert Device Repairs - Phones, Laptops, Computers & Game Consoles",
  phone: "(915) 787-9448",
  address: "14900 William Meshel Dr, El Paso, TX 79938",
  hours: "Open Daily - Closes at 2:00 AM",
  rating: 4.1,
  reviewCount: 270,
  email: "info@evolutioncellrepairs.com",
  facebook: "https://facebook.com/evolutioncellrepairs",
  identity: {
    latinoOwned: true,
    lgbtqFriendly: true
  }
};

export const services = [
  {
    id: 1,
    name: "Screen Repair",
    description: "Cracked or shattered screen? We replace iPhone and Android screens with high-quality parts, usually same-day.",
    icon: "Smartphone",
    price: "Starting at $79",
    duration: "30-60 minutes"
  },
  {
    id: 2,
    name: "Battery Replacement",
    description: "Phone dying quickly? We replace worn-out batteries to restore your device's power and performance.",
    icon: "Battery",
    price: "Starting at $49",
    duration: "20-30 minutes"
  },
  {
    id: 3,
    name: "Charging Port Repair",
    description: "Can't charge your phone? We fix or replace damaged charging ports for all major phone models.",
    icon: "Cable",
    price: "Starting at $59",
    duration: "30-45 minutes"
  },
  {
    id: 4,
    name: "Water Damage Repair",
    description: "Dropped your phone in water? Our specialists can diagnose and repair water-damaged devices.",
    icon: "Droplets",
    price: "Starting at $89",
    duration: "1-2 hours"
  },
  {
    id: 5,
    name: "iPhone Repair",
    description: "Complete iPhone repair services for all models - from screen replacements to complex logic board repairs.",
    icon: "Smartphone",
    price: "Varies by repair",
    duration: "30 minutes - 2 hours"
  },
  {
    id: 6,
    name: "Android Repair",
    description: "Expert repair services for Samsung, Google Pixel, LG, and all Android devices.",
    icon: "Smartphone",
    price: "Varies by repair",
    duration: "30 minutes - 2 hours"
  },
  {
    id: 7,
    name: "Laptop Repair",
    description: "Professional laptop repair for all brands - screen replacements, keyboard repairs, hardware upgrades, and more.",
    icon: "Laptop",
    price: "Starting at $99",
    duration: "1-3 hours"
  },
  {
    id: 8,
    name: "Computer Repair",
    description: "Desktop computer repairs including hardware diagnostics, component replacement, virus removal, and system optimization.",
    icon: "MonitorSmartphone",
    price: "Starting at $79",
    duration: "1-4 hours"
  },
  {
    id: 9,
    name: "Game Console Repair",
    description: "Repair services for PlayStation, Xbox, Nintendo Switch - from disc drive issues to overheating problems.",
    icon: "Gamepad2",
    price: "Starting at $89",
    duration: "1-3 hours"
  },
  {
    id: 10,
    name: "Device Diagnostics",
    description: "Not sure what's wrong? We offer free diagnostics to identify issues with any device.",
    icon: "SearchCheck",
    price: "FREE",
    duration: "15-30 minutes"
  },
  {
    id: 11,
    name: "Same-Day Repairs",
    description: "Most repairs completed the same day. Walk-ins welcome, or call ahead to reserve your spot.",
    icon: "Clock",
    price: "No extra charge",
    duration: "Same day"
  }
];

export const reviews = [
  {
    id: 1,
    name: "Maria Rodriguez",
    rating: 5,
    date: "2 weeks ago",
    text: "Excellent service! My iPhone screen was completely shattered and they fixed it in under an hour. The price was very reasonable and the staff was super friendly. Highly recommend!",
    verified: true
  },
  {
    id: 2,
    name: "James Chen",
    rating: 5,
    date: "1 month ago",
    text: "Best phone repair shop in El Paso! They replaced my battery and charging port same day. Really appreciate their late hours - I was able to come by after work at 9 PM. Professional and fast!",
    verified: true
  },
  {
    id: 3,
    name: "Sofia Martinez",
    rating: 4,
    date: "3 weeks ago",
    text: "Great experience overall. Fixed my Samsung screen quickly and professionally. Price was fair. Only wish they had slightly more parking, but that's minor. Will definitely return if needed!",
    verified: true
  },
  {
    id: 4,
    name: "David Thompson",
    rating: 5,
    date: "1 week ago",
    text: "Dropped my phone in the pool and thought it was done for. Evolution Cell Phone Repairs saved it! Water damage repair was successful and my phone works like new. Can't thank them enough!",
    verified: true
  },
  {
    id: 5,
    name: "Ana Garcia",
    rating: 5,
    date: "2 months ago",
    text: "I've been to several repair shops and this is by far the best. They're honest, fast, and their prices can't be beat. Fixed my charging port in 20 minutes while I waited. Amazing!",
    verified: true
  },
  {
    id: 6,
    name: "Michael Lee",
    rating: 4,
    date: "3 weeks ago",
    text: "Quick and reliable service. They diagnosed my phone issue for free and gave me honest advice. Ended up getting my screen replaced and it looks perfect. Good customer service!",
    verified: true
  },
  {
    id: 7,
    name: "Isabella Hernandez",
    rating: 5,
    date: "1 month ago",
    text: "Love this place! They're always friendly and helpful. I've had multiple repairs done here over the years and they never disappoint. The late hours are super convenient too!",
    verified: true
  },
  {
    id: 8,
    name: "Robert Wilson",
    rating: 5,
    date: "2 weeks ago",
    text: "Professional, efficient, and affordable. My iPhone was fixed perfectly and the warranty they offer gives me peace of mind. Definitely the go-to place for phone repairs in El Paso!",
    verified: true
  }
];

export const faqs = [
  {
    question: "Do you offer walk-in service?",
    answer: "Yes! Walk-ins are always welcome. However, calling ahead can help us prepare for your repair and reduce wait times."
  },
  {
    question: "How long does a typical repair take?",
    answer: "Most repairs like screen replacements and battery changes take 30-60 minutes. More complex repairs may take 1-2 hours. We offer same-day service for most repairs."
  },
  {
    question: "Do you offer a warranty on repairs?",
    answer: "Yes, we provide a warranty on all parts and labor. The warranty period varies by repair type - ask our technicians for specific details."
  },
  {
    question: "What brands do you repair?",
    answer: "We repair all major brands including Apple iPhone, Samsung, Google Pixel, LG, Motorola, and other Android devices."
  },
  {
    question: "Do you use original parts?",
    answer: "We use high-quality replacement parts that meet or exceed OEM specifications. Original parts are available upon request for certain repairs."
  },
  {
    question: "Why are you open so late?",
    answer: "We understand that phone emergencies don't follow a 9-5 schedule! Our late hours (open until 2 AM) mean you can get your device repaired when it's convenient for you."
  }
];

export const whyChooseUs = [
  {
    title: "Expert Technicians",
    description: "Our certified technicians have years of experience repairing all major phone brands and models.",
    icon: "Award"
  },
  {
    title: "Fast Service",
    description: "Most repairs completed same-day. We value your time and get you back to your device quickly.",
    icon: "Zap"
  },
  {
    title: "Quality Parts",
    description: "We use only high-quality replacement parts backed by our warranty.",
    icon: "Shield"
  },
  {
    title: "Honest Pricing",
    description: "No hidden fees. We provide upfront pricing and free diagnostics on all devices.",
    icon: "DollarSign"
  },
  {
    title: "Late Night Hours",
    description: "Open until 2 AM daily because we know phone problems don't wait.",
    icon: "Moon"
  },
  {
    title: "Community Focused",
    description: "Proudly Latino-owned and LGBTQ+ friendly. Everyone is welcome here.",
    icon: "Heart"
  }
];
